export default class ApiResponse {

    static fromError (err) {
        const resp = new ApiResponse()
        resp.raw = err
        resp.headers = err.headers

        if (typeof err.response === 'undefined' || typeof err.response.status === 'undefined') {
            resp.code = 500
            resp.message = 'errors.apiCommunication'
            return resp
        }

        resp.code = err.response.status
        
        if (err.response.data instanceof Object) {
            if (typeof err.response.data.message === 'string') {
                resp.message = err.response.data.message
            }
            if (typeof err.response.data.data !== 'undefined') {
                resp.data = err.response.data.data
            }
        }

        return resp
    }

    static fromRawResponse (raw) {
        if (typeof raw.status === 'undefined' || raw.status !== 200) {
            return ApiResponse.fromError(raw)
        }

        const resp = new ApiResponse()
        resp.code = raw.status
        resp.raw = raw
        resp.headers = raw.headers

        if (typeof raw.data !== 'undefined' && raw.data !== null) {
            if (typeof raw.data.message === 'string') {
                resp.message = raw.data.message
            }
            if (typeof raw.data !== 'undefined') {
                resp.data = raw.data
            }
        }

        return resp
    }

    constructor () {
        this.raw = null
        this.code = 200
        this.message = ''
        this.data = null
        this.headers = {}
    }

}
